module.exports = __webpack_public_path__ + "static/media/opet_background_800x216.407af0ec.png";